const RELATED_KEY = "ISP_PRODUCTS_VIEWED_SESSION_2";
const RELATED_KEY_LENGTH_LIMIT = 10;
export default function updateRecentSearches(params) {
    var _a, _b, _c, _d, _e, _f, _g;
    const anyParams = params;
    const id = (_c = (_b = (_a = anyParams.id) !== null && _a !== void 0 ? _a : anyParams.product_id) !== null && _b !== void 0 ? _b : anyParams.pid) !== null && _c !== void 0 ? _c : null;
    const query = (_f = (_e = (_d = anyParams.original_search_query) !== null && _d !== void 0 ? _d : anyParams.serp) !== null && _e !== void 0 ? _e : anyParams.original_smart_navigation) !== null && _f !== void 0 ? _f : null;
    if (!id) {
        return;
    }
    const now = parseInt(String(Date.now() / 1000), 10); // sec since 1970...
    const products = JSON.parse((_g = localStorage.getItem(RELATED_KEY)) !== null && _g !== void 0 ? _g : '[]');
    let newProducts = [];
    const ids = new Set();
    newProducts.push([Number(id), now, query]);
    ids.add(Number(id));
    for (let i = 0; i < products.length && newProducts.length < RELATED_KEY_LENGTH_LIMIT; i++) {
        if (!ids.has(Number(products[i][0])) && (now - products[i][1]) <= 5 * 60 * 60 * 24) {
            newProducts.push(products[i]);
            ids.add(Number(products[i][0]));
        }
    }
    localStorage.setItem(RELATED_KEY, JSON.stringify(newProducts));
}
//# sourceMappingURL=updateRecentSearches.js.map